var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "social-wrap",
      class: { "no-cursor": _vm.bindAccountNum === 1 && _vm.isBind },
      on: { click: _vm.handleBind },
    },
    [
      _c("div", { staticClass: "google-btn" }, [
        _c("div", { ref: "googleBtn" }),
      ]),
      _c("div", { staticClass: "wrap", class: { unbind: !_vm.isBind } }, [
        _vm._m(0),
        _c(
          "div",
          {
            staticClass: "account-name",
            class: { "no-arr": _vm.bindAccountNum === 1 && _vm.isBind },
          },
          [
            _vm.isBind
              ? [_vm._v(_vm._s(_vm.isBind))]
              : [_vm._v(_vm._s(_vm.$t("web_unbind")))],
          ],
          2
        ),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "logo-wrap" }, [
      _c("span", { staticClass: "logo google" }),
      _c("span", { staticClass: "name" }, [_vm._v("Google")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }